import { usePublicCompanyLead } from '@/features/publicCompanyLeadsFunnel/hooks/usePublicCompanyLead'
import { useParams } from 'react-router-dom'
import Form from './form'

const Update = () => {
  const { id, publicCompanyLeadId } = useParams()
  const { data: publicCompanyLead, isPending: isLoadingPublicCompanyLead } = usePublicCompanyLead(
    publicCompanyLeadId || '',
  )

  return (
    <>
      {!isLoadingPublicCompanyLead && !!publicCompanyLead && (
        <Form
          contact={publicCompanyLead.contacts?.find((contact) => contact.id === id)}
          publicCompanyLeadState={publicCompanyLead.state}
          publicCompanyRestContacts={publicCompanyLead?.contacts?.filter((contact) => contact.id !== id) || []}
          publicCompanyLeadName={publicCompanyLead?.display_name}
        />
      )}
    </>
  )
}

export default Update
